import React, { useCallback } from 'react';
import { NavigationTextButton } from 'design-system/TextButton';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { Tier } from '../entities';
import { selectActiveTier, selectDefaultPaywallTier, selectShouldSeePremiumTrialScreen, } from '../selectors';
const CompareButton = ({ isInTab, alwaysShow, tier, onPressIn, onPressOut, }) => {
    const activeTier = useAppSelector(selectActiveTier);
    const defaultPaywallTier = useAppSelector(selectDefaultPaywallTier);
    const shouldSeePremiumTrialScreen = useAppSelector((store) => selectShouldSeePremiumTrialScreen(store, tier || defaultPaywallTier));
    const navigation = useMainStackNavigation();
    const handlePress = useCallback(() => {
        navigation.navigateDeprecated('TiersCompareTable', {
            showClose: Boolean(isInTab),
        });
    }, [isInTab]);
    if (activeTier === Tier.ultimate ||
        (shouldSeePremiumTrialScreen && !alwaysShow)) {
        return null;
    }
    return (<NavigationTextButton small onPress={handlePress} onPressIn={onPressIn} onPressOut={onPressOut} text="Compare"/>);
};
export default CompareButton;
